import { useContext } from "react";
import { TeamContext } from "./TeamContext";

export const useTeam = () => {
  const context = useContext(TeamContext);

  return context;
};
